import {
  Box,
  Button,
  Icon,
  Paper,
  Skeleton,
  Typography,
  useMediaQuery,
  useTheme,
  TextField,
  IconButton,
} from "@mui/material";
import { useAppThemeContext } from "../../contexts";

interface IFerramentaDeDetalheProps {
  textoBotaoNovo?: string;

  mostrarBotaoNovo?: boolean;
  mostrarBotaoVoltar?: boolean;
  mostrarBotaoApagar?: boolean;
  mostrarBotaoSalvar?: boolean;
  mostrarBotaoSalvarEVoltar?: boolean;

  mostrarBotaoNovoCarregando?: boolean;
  mostrarBotaoVoltarCarregando?: boolean;
  mostrarBotaoApagarCarregando?: boolean;
  mostrarBotaoSalvarCarregando?: boolean;
  mostrarBotaoSalvarEVoltarCarregando?: boolean;

  mostrarBarraDeBusca?: boolean;
  valorBarraDeBusca?: string;
  erroBarraDeBusca?: boolean;
  placeholderBarraDeBusca?: string;
  aoBuscarBarraDeBusca?: () => void;
  aoAlterarBarraDeBusca?: (valor: string) => void;

  aoClicarEmNovo?: () => void;
  aoClicarEmVoltar?: () => void;
  aoClicarEmApagar?: () => void;
  aoClicarEmSalvar?: () => void;
  aoClicarEmSalvarEVoltar?: () => void;
}

export const FerramentaDeDetalhe: React.FC<IFerramentaDeDetalheProps> = ({
  textoBotaoNovo = "Novo",

  mostrarBotaoNovo = true,
  mostrarBotaoVoltar = true,
  mostrarBotaoApagar = true,
  mostrarBotaoSalvar = true,
  mostrarBotaoSalvarEVoltar = false,

  mostrarBotaoNovoCarregando = false,
  mostrarBotaoVoltarCarregando = false,
  mostrarBotaoApagarCarregando = false,
  mostrarBotaoSalvarCarregando = false,
  mostrarBotaoSalvarEVoltarCarregando = false,

  mostrarBarraDeBusca = false,
  valorBarraDeBusca = "",
  erroBarraDeBusca = false,
  placeholderBarraDeBusca = "Buscar",
  aoBuscarBarraDeBusca,
  aoAlterarBarraDeBusca,

  aoClicarEmNovo,
  aoClicarEmVoltar,
  aoClicarEmApagar,
  aoClicarEmSalvar,
  aoClicarEmSalvarEVoltar,
}) => {
  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down("sm"));
  const mdDown = useMediaQuery(theme.breakpoints.down("md"));
  const { themeName } = useAppThemeContext();

  return (
    <Box
      component={Paper}
      height={theme.spacing(5)}
      marginX={1}
      padding={1}
      paddingX={2}
      display="flex"
      gap={1}
      alignItems="center"
    >
      {mostrarBotaoVoltar && !mostrarBotaoVoltarCarregando && (
        <Button
          color={themeName === "light" ? "secondary" : "primary"}
          disableElevation
          variant="outlined"
          startIcon={
            <Icon color={themeName === "light" ? "secondary" : "primary"}>
              arrow_back
            </Icon>
          }
          onClick={aoClicarEmVoltar}
        >
          <Typography
            variant="button"
            noWrap
            color={themeName === "light" ? "secondary" : "primary"}
          >
            Voltar
          </Typography>
        </Button>
      )}

      {mostrarBotaoVoltarCarregando && (<Skeleton width={110} height={60} />)}

      {mostrarBarraDeBusca && (
        <Box flex={1} maxWidth={400}>
          <TextField
            size="small"
            fullWidth
            label="Buscar"
            placeholder={placeholderBarraDeBusca}
            value={valorBarraDeBusca}
            error={erroBarraDeBusca}
            onChange={(e) => aoAlterarBarraDeBusca?.(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                aoBuscarBarraDeBusca?.();
                e.preventDefault();
              }
            }}
            InputProps={{
              endAdornment: (
                <IconButton onClick={aoBuscarBarraDeBusca}>
                  <Icon color={erroBarraDeBusca ? "error" : "primary"}>
                    search
                  </Icon>
                </IconButton>
              ),
            }}
          />
        </Box>
      )}

      <Box flex="1" display="flex" justifyContent="end" gap={1}>
        {mostrarBotaoApagar && !mostrarBotaoApagarCarregando && (
          <Button
            color="error"
            disableElevation
            variant="outlined"
            startIcon={<Icon>delete</Icon>}
            onClick={aoClicarEmApagar}
          >
            <Typography variant="button" noWrap>
              Desativar
            </Typography>
          </Button>
        )}
        {mostrarBotaoApagarCarregando && (<Skeleton width={110} height={60} />)}

        {mostrarBotaoNovo && !mostrarBotaoNovoCarregando && !smDown && (
          <Button
            color="success"
            disableElevation
            variant="outlined"
            startIcon={<Icon color="success">add</Icon>}
            onClick={aoClicarEmNovo}
          >
            <Typography variant="button" noWrap color="success.main">
              {textoBotaoNovo}
            </Typography>
          </Button>
        )}
        {mostrarBotaoNovoCarregando && !smDown && (
          <Skeleton width={110} height={60} />
        )}

        {mostrarBotaoSalvarEVoltar &&
          !mostrarBotaoSalvarEVoltarCarregando &&
          !smDown &&
          !mdDown && (
            <Button
              color={themeName === "light" ? "secondary" : "primary"}
              disableElevation
              variant="outlined"
              startIcon={
                <Icon color={themeName === "light" ? "secondary" : "primary"}>
                  save
                </Icon>
              }
              onClick={aoClicarEmSalvarEVoltar}
            >
              <Typography
                variant="button"
                color={themeName === "light" ? "secondary" : "primary"}
                noWrap
              >
                Salvar e voltar
              </Typography>
            </Button>
          )}
        {mostrarBotaoSalvarEVoltarCarregando && !smDown && !mdDown && (
          <Skeleton width={180} height={60} />
        )}

        {mostrarBotaoSalvar && !mostrarBotaoSalvarCarregando && (
          <Button
            color="primary"
            disableElevation
            variant="contained"
            startIcon={<Icon>save</Icon>}
            onClick={aoClicarEmSalvar}
          >
            <Typography variant="button" noWrap>
              Salvar
            </Typography>
          </Button>
        )}
        {mostrarBotaoSalvarCarregando && <Skeleton width={110} height={60} />}
      </Box>
    </Box>
  );
};
